import React from "react";
import {Global, ThemeProvider} from "@emotion/react";
import {Brands, globalReset, EnabledFeaturesContext} from "./internal";
import {globalFonts} from "./globalFonts";
import {themes} from "./theme";
import {FontTracker} from "./FontTracker";

type StitchStyleProviderProps = {
  /**
   * Sets the loaded brand theme
   */
  brand: Brands;
  children?: React.ReactNode;
  enabledFeatures?: Record<string, boolean>;
};

export function StitchStyleProviderBase({
  brand,
  children,
  enabledFeatures = {},
}: StitchStyleProviderProps): JSX.Element {
  // Apply gap 2022 colors feature flag (FUI-3835)
  if (
    enabledFeatures["gap-colors-2022"] &&
    (brand === Brands.Gap || brand === Brands.GapFactoryStore)
  ) {
    themes[brand].color.b1 = "#2B2B2B";
    themes[brand].color.b2 = "#2B2B2B";
    themes[brand].color.b3 = "#2B2B2B";
    if (brand === Brands.Gap) {
      themes[brand].color.g2 = "#757575";
      themes[brand].color.g5 = "#E9E9E9";
    }
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <ThemeProvider theme={themes[brand] as any}>{children}</ThemeProvider>
  );
}

export function StitchStyleProvider({
  brand,
  children,
  enabledFeatures = {},
}: StitchStyleProviderProps): JSX.Element {
  return (
    <StitchStyleProviderBase brand={brand} enabledFeatures={enabledFeatures}>
      <EnabledFeaturesContext.Provider value={enabledFeatures}>
        <Global
          styles={[
            globalFonts(brand, enabledFeatures),
            globalReset(themes[brand]),
          ]}
        />
        {children}
        <FontTracker brand={brand} />
      </EnabledFeaturesContext.Provider>
    </StitchStyleProviderBase>
  );
}
